import usePrivateAxios from '@/common/api/usePrivateAxios'
import { getRailsUpdate } from '@/common/utils/getRailsUpdate'
import { mapToDeletion } from '@/common/utils/railsHelpers'
import { CompanyData } from '@/features/companies/types/companies.type'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateTefInputMode {
  companyId?: string
  clientCompanyTefInputModes: CompanyData['client_company_tef_input_modes']
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdateTefInputMode = ({
  companyId,
  clientCompanyTefInputModes,
  onSuccess,
  onError,
}: UseUpdateTefInputMode) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateTefInputMode'],
    mutationFn: async (selectedTefInputModes: { tef_input_mode_id: string }[]) => {
      const company = {
        client_company_tef_input_modes_attributes: getRailsUpdate(
          clientCompanyTefInputModes,
          selectedTefInputModes,
          (item) => item.tef_input_mode.id,
          (item) => item.tef_input_mode_id,
          mapToDeletion,
          (value) => ({ ...value }),
        ),
      }

      await privateAxios.put(`/client/companies/${companyId}/update_tef_inputs`, {
        company,
      })
    },
    onSuccess,
    onError,
  })
}
